import { Switch } from "antd"
import { ViewItem } from "./itemModel"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faLock } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  item: ViewItem
  checked: boolean
  disabled?: boolean
  onChange: (value: boolean) => void
}

const LockableSwitch = ({ item, checked, disabled, onChange }: Props) => {
  if (item.isEmptyRow) {
    return <></>
  }

  const isDisabled = item.isEntireRowDisabled || disabled
  const lockIcon = isDisabled ? <FontAwesomeIcon icon={faLock} /> : undefined
  return <Switch
    checked={checked}
    disabled={isDisabled}
    onChange={onChange}
    checkedChildren={lockIcon}
    unCheckedChildren={lockIcon}
  />
}
export default LockableSwitch
